import axios from "axios";

import ENV from "../../util/env-config";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${sessionStorage._sessionToken}`,
        Pragma: "no-cache",
      },
    };
  }

  static getArticles(requestData) {
    return axios.post(ENV.apiBaseB + "/articles/list", requestData, this.requestConfig());
  }

  static addArticle(requestData) {
    return axios.post(ENV.apiBaseB + "/articles/create", requestData, this.requestConfig());
  }

  static updateArticle(requestData) {
    return axios.post(ENV.apiBaseB + "/articles/update", requestData, this.requestConfig());
  }

  static getCategories() {
    return axios.get(ENV.apiBaseB + "/articles/list_categories", this.requestConfig());
  }
}

export default Service;
